import Vue from 'vue'
import Router from 'vue-router'
// import login from '@/pages/login/login'
// import index from '@/pages/index/index'
// import modifyInfo from '@/pages/index/modifyInfo'
// import modifyPwd from '@/pages/index/modifyPwd'
// import booth from '@/pages/fee/booth'
// import feeSuccessful from '@/pages/fee/feeSuccessful'
// import fixedFee from '@/pages/fee/fixedFee'
// import fee from '@/pages/fee/fee'
// import shopList from '@/pages/order/shopList'
// import feeComfirmation from '@/pages/fee/feeConfirmation'
// import feePayment from '@/pages/fee/feePayment'
// import feeOfflinePayment from '@/pages/fee/feeOfflinePayment'
// import shopDetail from '@/pages/order/shopDetail'
// import foregift from '@/pages/foregift/foregift'
// import foregiftApply from '@/pages/foregift/apply'
// import feeDetail from '@/pages/foregift/feeDetail'
// import order from '@/pages/order/order'
// import orinaryOrderDetail from '@/pages/order/order_detail/orinary'
// import insuranceOrderDetail from '@/pages/order/order_detail/insurance'
import moment from 'moment'
import 'moment/locale/zh-cn'
// import insuranceHome from '@/pages/insurance/insuranceHome'
// import main from '@/pages/index/main'
// import invoiceIndex from '@/pages/invoice/invoiceIndex'
// import invoiceApply from '@/pages/invoice/invoiceApply'
//
// import fasciaList from '@/pages/conference/fasciaList'
// import bookletList from '@/pages/conference/bookletList'
// import drawingsNotice from '@/pages/drawings/drawingsNotice'
// import drawingsIndex from '@/pages/drawings/drawingsIndex'
// import drawingsDetail from '@/pages/drawings/drawingsDetail'
// import drawings from '@/pages/drawings/drawings'
// import drawingsBoothConfirm from '@/pages/drawings/drawingsBoothConfirm'
// import drawingsBoothInfo from '@/pages/drawings/drawingsBoothInfo'
// import drawingsProducerInfo from '@/pages/drawings/drawingsProducerInfo'
// import drawingsUpload from '@/pages/drawings/drawingsUpload'
// import drawingsCarpet from '@/pages/drawings/drawingsCarpet'
// import drawingsEnd from '@/pages/drawings/drawingsEnd'
// import carLicenseApplyList from '@/pages/carLicenseApply/list'
// import carLicenseApplyDetail from '@/pages/carLicenseApply/detail'
// import carLicenseApplyAdd from '@/pages/carLicenseApply/add'
// import constructionPermitList from '@/pages/constructionPermit/list'
// import constructionPermitDetail from '@/pages/constructionPermit/detail'
// import constructionPermitAdd from '@/pages/constructionPermit/add'
// import boothInfo from '@/pages/booth/boothInfo'
// import wechatPayQrCode from '@/pages/wechatPay/qrCode'
Vue.use(Router)

moment.locale('zh-cn')
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '',
      component: () => import('@/pages/index/index'),
      children: [
        {
          path: '/',
          name: 'main',
          component: () => import('@/pages/index/main')
        },
        {
          path: '/404',
          name: '404',
          component: () => import('@/pages/404/index')
        },
        {
          path: '/success',
          name: 'success',
          component: () => import('@/pages/success/success')
        },
        {
          path: '/Exhibitors',
          name: 'Exhibitors',
          component: () => import('@/pages/Exhibitors/Exhibitors')
        },
        {
          path: '/OrderDocuments',
          name: 'OrderDocuments',
          component: () => import('@/pages/OrderDocuments/OrderDocuments')
        },
        {
          path: '/OrderDocuments/CertificateInfo',
          name: 'CertificateInfo',
          component: () => import('@/pages/OrderDocuments/CertificateInfo/CertificateInfo')
        },
        {
          path: '/OrderDocuments/OrderPay',
          name: 'OrderPay',
          component: () => import('@/pages/OrderDocuments/OrderPay/OrderPay')
        },
        {
          path: '/notice/list',
          name: 'noticeList',
          component: () => import('@/pages/index/notice/list')
        },
        {
          path: '/notice/detail',
          name: 'noticeDetail',
          component: () => import('@/pages/index/notice/detail')
        },
        {
          path: '/wechatPayQrCode',
          name: 'wechatPayQrCode',
          component: () => import('@/pages/wechatPay/qrCode')
        },
        {
          path: '/boothInfo',
          name: 'boothInfo',
          component: () => import('@/pages/booth/boothInfo')
        },
        {
          path: '/booth/boothList',
          name: 'boothList',
          component: () => import('@/pages/booth/boothList')
        },
        {
          path: '/booth/boothDetail',
          name: 'boothDetail',
          component: () => import('@/pages/booth/boothDetail')
        },
        {
          path: '/paymentSuccess',
          name: 'paymentSuccess',
          component: () => import('@/pages/OrderDocuments/OrderPay/paymentSuccess')
        },
        {
          path: '/invoiceIndex',
          name: 'invoiceIndex',
          component: () => import('@/pages/invoice/invoiceIndex')
        },
        {
          path: '/invoiceApply',
          name: 'invoiceApply',
          component: () => import('@/pages/invoice/invoiceApply')
        },
        {
          path: '/invoiceDetail',
          name: 'invoiceDetail',
          component: () => import('@/pages/invoice/invoiceDetail')
        },
        {
          path: '/invoiceConfirmation',
          name: 'invoiceConfirmation',
          component: () => import('@/pages/invoice/invoiceConfirmation')
        },
        {
          path: '/modifyInfo',
          name: 'modifyInfo',
          component: () => import('@/pages/index/modifyInfo')
        },
        {
          path: '/personalCenter',
          name: 'personalCenter',
          component: () => import('@/pages/index/personalCenter')
        },
        {
          path: '/EnterpriseCertification',
          name: 'EnterpriseCertification',
          component: () => import('@/pages/index/EnterpriseCertification')
        },
        {
          path: '/modifyPwd',
          name: 'modifyPwd',
          component: () => import('@/pages/index/modifyPwd')
        },
        {
          path: '/foregift',
          name: 'foregift',
          component: () => import('@/pages/foregift/foregift')
        },
        {
          path: '/foregift/apply',
          name: 'foregiftApply',
          component: () => import('@/pages/foregift/apply')
        },
        {
          path: '/foregift/feeDetail',
          name: 'feeDetail',
          component: () => import('@/pages/foregift/feeDetail')
        },
        {
          path: '/carLicenseApply/list',
          name: 'carLicenseApplyList',
          component: () => import('@/pages/carLicenseApply/list')
        },
        {
          path: '/carLicenseApply/detail',
          name: 'carLicenseApplyDetail',
          component: () => import('@/pages/carLicenseApply/detail')
        },
        {
          path: '/carLicenseApply/add',
          name: 'carLicenseApplyAdd',
          component: () => import('@/pages/carLicenseApply/add')
        },
        {
          path: '/addBooth',
          name: 'addBooth',
          component: () => import('@/component/addBooth/addBooth')
        },
        {
          path: '/w',
          name: 'fee',
          component: () => import('@/pages/fee/fee'),

          children: [
            {
              path: '/booth',
              name: 'booth',
              component: () => import('@/pages/fee/booth')
            },
            {
              path: '/feeMakeSure',
              name: 'feeMakeSure',
              component: () => import('@/pages/fee/feeMakeSure')
            },
            {
              path: '/feePayment',
              name: 'feePayment',
              component: () => import('@/pages/fee/feePayment')
            },
            {
              path: '/cloudPayment',
              name: 'cloudPayment',
              component: () => import('@/pages/fee/cloudPayment')
            },
            {
              path: '/feeSuccessful',
              name: 'feeSuccessful',
              component: () => import('@/pages/fee/feeSuccessful')
            },
            {
              path: '/feeOfflinePayment',
              name: 'feeOfflinePayment',
              component: () => import('@/pages/fee/feeOfflinePayment')
            },
            {
              path: '/fixedFee',
              name: 'fixedFee',
              component: () => import('@/pages/fee/fixedFee')
            },
            {
              path: '/shopList',
              name: 'shopList',
              component: () => import('@/pages/fee/shopList')
            },
            {
              path: '/SettlementList',
              name: 'SettlementList',
              component: () => import('@/pages/fee/SettlementList')
            },
            {
              path: '/shopDetail',
              name: 'shopDetail',
              component: () => import('@/pages/order/shopDetail')
            },
            {
              path: '/foodList',
              name: 'foodList',
              component: () => import('@/pages/bookFood/foodList')
            },
            {
              path: '/foodOrderList',
              name: 'foodOrderList',
              component: () => import('@/pages/bookFood/foodOrderList')
            },
            {
              path: '/foodMakeSure',
              name: 'foodMakeSure',
              component: () => import('@/pages/bookFood/foodMakeSure')
            }
          ]
        },
        {
          path: '/order',
          name: 'order',
          component: () => import('@/pages/order/order')
        },
        {
          path: '/order/insurance',
          name: 'insuranceOrderDetail',
          component: () => import('@/pages/order/order_detail/insurance')
        },
        {
          path: '/order/ordinary',
          name: 'orinaryOrderDetail',
          component: () => import('@/pages/order/order_detail/ordinary')
        },
        {
          path: '/order/cloudordinary',
          name: 'cloudorinaryOrderDetail',
          component: () => import('@/pages/order/order_detail/cloudordinary')
        },
        {
          path: '/fasciaList',
          name: 'fasciaList',
          component: () => import('@/pages/conference/fasciaList')
        },
        {
          path: '/bookletList',
          name: 'bookletList',
          component: () => import('@/pages/conference/bookletList')
        },
        {
          path: '/constructionPermit/list',
          name: 'constructionPermitList',
          component: () => import('@/pages/constructionPermit/list')
        },
        {
          path: '/constructionPermit/detail',
          name: 'constructionPermitDetail',
          component: () => import('@/pages/constructionPermit/detail')
        },
        {
          path: '/constructionPermit/add',
          name: 'constructionPermitAdd',
          component: () => import('@/pages/constructionPermit/add')
        },
        {
          path: '/drawingsNotice',
          name: 'drawingsNotice',
          component: () => import('@/pages/drawings/drawingsNotice')
        },
        {
          path: '/drawingsIndex',
          name: 'drawingsIndex',
          component: () => import('@/pages/drawings/drawingsIndex')
        },
        {
          path: '/drawingsDetail',
          name: 'drawingsDetail',
          component: () => import('@/pages/drawings/drawingsDetail')
        },
        {
          path: '/drawings',
          component: () => import('@/pages/drawings/drawings'),

          children: [
            {
              path: '/',
              redirect: { name: 'drawingsBoothConfirm' }
            },
            {
              path: '/drawingsBoothConfirm',
              name: 'drawingsBoothConfirm',
              component: () => import('@/pages/drawings/drawingsBoothConfirm')
            },
            {
              path: '/drawingsBoothInfo',
              name: 'drawingsBoothInfo',
              component: () => import('@/pages/drawings/drawingsBoothInfo')
            },
            {
              path: '/drawingsProducerInfo',
              name: 'drawingsProducerInfo',
              component: () => import('@/pages/drawings/drawingsProducerInfo')
            },
            {
              path: '/drawingsUpload',
              name: 'drawingsUpload',
              component: () => import('@/pages/drawings/drawingsUpload')
            },
            {
              path: '/drawingsCarpet',
              name: 'drawingsCarpet',
              component: () => import('@/pages/drawings/drawingsCarpet')
            },
            {
              path: '/drawingsCar',
              name: 'drawingsCar',
              component: () => import('@/pages/carLicenseApply/add')
            },
            {
              path: '/drawingsConstruction',
              name: 'drawingsConstruction',
              component: () => import('@/pages/constructionPermit/add')
            },
            {
              path: '/drawingsEnd',
              name: 'drawingsEnd',
              component: () => import('@/pages/drawings/drawingsEnd')
            }
          ]
        },
        {
          path: '/insuranceHome',
          name: 'insuranceHome',
          component: () => import('@/pages/insurance/insuranceHome')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login/login')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js